module.exports = __webpack_public_path__ + "static/media/AB_K22_2.e90fcf2d.jpg";